import React, { useEffect } from "react";
import { ContaminantesApi } from "../api/ContaminantesApi";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";

export const useContaminantes = (analisisDetalle) => {
    const [contaminantes, setContaminantes] = React.useState([]);

    const { getContaminantes, cargando } = ContaminantesApi();

    // Async loaders
    const loadContaminantes = useDebouncedAsyncSelect(function (search) {
        return getContaminantes({ search: search, no_paginar: true });
    });

    useEffect(() => {
        if (analisisDetalle && analisisDetalle.contaminantes) {
            setContaminantes(analisisDetalle.contaminantes || []);
        }
    }, [analisisDetalle && analisisDetalle.contaminantes]);

    const Agregar = () => {
        setContaminantes((prev) => [
            ...prev,
            {
                material_contaminante: null,
                nivel_contaminacion: null,
            },
        ]);
    };

    const Eliminar = (index) => {
        setContaminantes((prev) => {
            const copy = [...prev];
            copy.splice(index, 1);
            return copy;
        });
    };

    const Actualizar = (index, field, value) => {
        setContaminantes((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value, _dirty: true } : item,
            ),
        );
    };

    const SetAll = (data) => {
        setContaminantes(data || []);
    };

    return {
        contaminantes,
        loadContaminantes,

        Agregar,
        Eliminar,
        Actualizar,
        SetAll,
    };
};
